import { render, staticRenderFns } from "./ScoreEvolutionScreen.vue?vue&type=template&id=7c192506&scoped=true&"
import script from "./ScoreEvolutionScreen.vue?vue&type=script&lang=js&"
export * from "./ScoreEvolutionScreen.vue?vue&type=script&lang=js&"
import style0 from "./ScoreEvolutionScreen.vue?vue&type=style&index=0&id=7c192506&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c192506",
  null
  
)

export default component.exports